import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
  },
  iconUploadContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  multiselectTitle: {
    marginBottom: '4px',
  },
  iconPreview: { maxWidth: 200, maxHeight: '100%' },
})

export { useStyles }
